import styled from '@emotion/styled';

export const Hr = styled.hr`
    height: 1px;
    background-color: ${({ theme }) => theme.greys[50]};
    margin: 1.5rem 0;
    border: none;
`;
